import React from 'react';
import { Helmet } from "react-helmet";

export default class PopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: [],
            Image: []
        };
    }
    componentDidMount() {
        // console.log('api at header' + Globals.language_based_api);
        const url = 'https://s3.ap-south-1.amazonaws.com/dev-media.webdunia.com/public_html/popup/popup.json';
        fetch(url)
            .then((res) => res.json())
            .then((data) => {

                this.setState({
                    status: data.language.te.status,
                    Image: data.language.te.popup_image

                })
            })
    }

    render() {
       // console.log("state", this.state);
        return (
            <>
                {(() => {
                    if (this.state.status == 1) {
                        return (
                            <>

                                <Helmet>
                                    <script src="/js/popup.js" async ></script>
                                </Helmet>
                                <div class="contest_popup_wrap" id="festival_popup">
                                    <div class="contest_bann_img">
                                        <button class="cont_close_btn" aria-label="webdunia"><img src={require("../assets/img/navratri/f_closebtn.png").default} /></button>
                                        <a href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en"><img src={this.state.Image} /></a>
                                    </div>
                                </div>
                            </>
                        )
                    }
                })()}

            </>
        )
    }

}
